<template>
    <div class="about-us app">
        <HeaderChild></HeaderChild>
        <div class="main-content mb8">
            <div class="group-info">
                <p class="fwb fs16">集团名称</p>
                <div class="quill-editor">
                    <div class="ql-container ql-snow">
                        <div class="ql-editor editor pre-wrap" v-html="info.introduce_content"></div>
                    </div>
                </div>
            </div>
        </div>
        <div class="main-content">
            <div class="us-info color-blank">
                <p class="fwb fs16 mb16">联系我们</p>
                <ul class="info fs14">
                    <li class="mb16"><img src="../../assets/images/area.png" alt="" class="mr8 wh20"><span>地址：{{data.address}}</span></li>
                    <li class="mb16"><img src="../../assets/images/phone.png" alt="" class="mr8 wh20"><span>电话：{{data.tel}}</span></li>
                    <li class="mb16" v-if="data.code"><img src="../../assets/images/code.png" alt="" class="mr8 wh20"><span>邮编：{{data.code}}</span></li>
                    <li v-if="data.fax"><img src="../../assets/images/fax.png" alt="" class="mr8 wh20"><span>传真：{{data.fax}}</span></li>
                </ul> 
            </div>
        </div>
    </div>
</template>

<script>
import HeaderChild from '@/components/HeaderChild'
export default {
    components: {
        HeaderChild
    },
    data() {
        return {
            data:'',//关于我门
            info:{}//集团介绍
        };
    },
    computed: {
        
    },
    created() {
        this.getInfo();//获取集团基本信息
        this.getContact();//关于我们
    },
    mounted() {
        
    },
    watch: {

    },
    methods: {
        getInfo(){
            this.$axios.post(this.api.about.intro,{},res =>{
                this.info=res.data;
            },err =>{
                this.info={};
            });
        },
        getContact(){
            this.$axios.post(this.api.about.contact,{},res =>{
                this.data=res.data;
            },err =>{
                this.data={};
            });
        }
    },
    
};
</script>

<style scoped lang="less">
.about-us{
    height:100vh;
    .main-content{
        padding:16px;
        background:#fff;
        .us-info{
            height:198px;
            span{
                height:20px;
                line-height:20px;
                display: inline-block;
                vertical-align:middle;
            }
        }
        .group-info{
            background:#fff;
        }
    }
}

</style>



// WEBPACK FOOTER //
// src/view/aboutUs/index.vue